import { EventbookingActionTypes } from './constants';
import {BookingRequestActionTypes} from "../booking_requests/constants";

const EVENTBOOKING_STATE = {
    eventbookings: [],
    eventbooking: {},
    total_pages: 1,
    filters: { },
    loading: false,
};

type EventbookingAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { eventbooking?: {} | null, loading?: boolean, +value?: boolean };

const EventbookingReducer = (state: State = EVENTBOOKING_STATE, action: EventbookingAction): any => {
    switch (action.type) {
        case EventbookingActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case EventbookingActionTypes.LIST_EVENTBOOKING: {
                    return {
                        ...state,
                        eventbookings: action.payload.data.eventbookings,
                        total_pages: action.payload.data.total_pages,
                        loading: false,
                    };
                }
                case EventbookingActionTypes.SHOW_EVENTBOOKING: {
                    return {
                        ...state,
                        eventbooking: action.payload.data,
                        loading: false,
                    };
                }
                case EventbookingActionTypes.CREATE_COMMENT: {
                    return {
                        ...state,
                        eventbooking: action.payload.data.eventbooking,
                        loading: false,
                    };
                }
                case EventbookingActionTypes.UPDATE_COMMENT: {
                    return {
                        ...state,
                        eventbooking: action.payload.data.eventbooking,
                        loading: false,
                    };
                }
                case EventbookingActionTypes.DELETE_COMMENT: {
                    return {
                        ...state,
                        eventbooking: action.payload.data.eventbooking,
                        loading: false,
                    };
                }
                case EventbookingActionTypes.FILTER_EVENTBOOKING: {
                    return {
                        ...state,
                        eventbookings: action.payload.data.eventbookings,
                        total_pages: action.payload.data.total_pages,
                        filters: state.filters,
                        loading: false
                    };
                }
                default:
                    return {...state};
            }

        case EventbookingActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case EventbookingActionTypes.LIST_EVENTBOOKING: {
                    return {
                        ...state,
                        error: action.payload.error,
                        eventbookings: [],
                        total_pages: 1,
                        loading: false,
                    };
                }
                case EventbookingActionTypes.SHOW_EVENTBOOKING: {
                    return {
                        ...state,
                        error: action.payload.error,
                        eventbooking: "",
                        loading: false,
                    };
                }
                case EventbookingActionTypes.FILTER_EVENTBOOKING: {
                    return {
                        ...state,
                        eventbookings: action.payload.data,
                        filters: state.filters,
                        loading: false
                    };
                }
                default:
                    return {...state};
            }

        case EventbookingActionTypes.LIST_EVENTBOOKING:
            return { ...state, loading: true, eventbookings: [], total_pages: 1 };
        case EventbookingActionTypes.SHOW_EVENTBOOKING:
            return { ...state, loading: true, eventbooking: "" };
        case EventbookingActionTypes.FILTER_EVENTBOOKING:
            return { ...state, loading: true, eventbookings: state.eventbookings, filters: state.filters };
        default:
            return { ...state };
    }
};

export default EventbookingReducer;